import { BoundingBoxObject, SpatialDatabase } from '../util';
import { Ray, RayTraceResult } from '../math';

export class PickingManager {
  private spatialDatabaseList: SpatialDatabaseItem[];

  constructor() {
    this.spatialDatabaseList = [];
  }

  public registerSpatialDatabase(
    spatialDatabase: SpatialDatabase<BoundingBoxObject>,
    name: string,
    callback: PickingCallback,
    priority?: number,
  ) {
    this.spatialDatabaseList.push({
      database: spatialDatabase,
      name: name,
      callback: callback,
      priority: priority || 0,
    });

    this.spatialDatabaseList.sort((a, b) => {
      return b.priority - a.priority;
    });
  }

  public unregisterSpatialDatabase(spatialDatabase: SpatialDatabase<BoundingBoxObject>) {
    for (let i = 0; i < this.spatialDatabaseList.length; i++) {
      if (this.spatialDatabaseList[i].database === spatialDatabase) {
        this.spatialDatabaseList.splice(i, 1);
        return;
      }
    }
  }

  public getRayIntersections(ray: Ray): Map<string, SpatialDatabaseHits> {
    let hitMap = new Map<string, SpatialDatabaseHits>();

    for (let spatialDb of this.spatialDatabaseList) {
      let hits = spatialDb.database.rayTrace(ray);
      if (hits && hits.length > 0) {
        hitMap.set(spatialDb.name, {
          ray: ray,
          hits: hits,
          callback: spatialDb.callback,
        });
      }
    }

    return hitMap;
  }
}

type SpatialDatabaseItem = {
  database: SpatialDatabase<BoundingBoxObject>;
  name: string;
  callback: PickingCallback;
  priority: number;
};

type PickingCallback = (name: string, type: string, hits: RayTraceResult[]) => boolean;

type SpatialDatabaseHits = {
  ray: Ray;
  hits: RayTraceResult[];
  callback: PickingCallback;
};
